// Code review - Completed
// Documentation - Completed
import React, { useState, useEffect } from "react";
import { mainTable } from "../css/Common";
import { roleMasterHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import Role from "../popup-containers/RolePopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

const RoleMaster = () => {
  const location = useLocation();
  //All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Role Master insert and edit useState hooks handling .
  const [mstRoleId, setMstRoleId] = useState("");
  const [roleData, setRoleData] = useState("");
  const [bindRoleMasterDatas, setbindRoleMasterDatas] = useState([]);

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  //Value store States
  const [roleFields, setRoleFields] = useState({
    roleGroups: "",
    description: "",
  });

  const [roleFieldsError, setRoleFieldsError] = useState({
    roleGroupsError: "",
    descriptionError: "",
  });

  // This is grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
    setVisibleUpdate(false);
    localStorage.setItem("screenMode", "add");
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    handleOpen(false);
    setSubmitBtnDisabled(false);
    setRoleFields({
      roleGroups: "",
      description: "",
    });

    setRoleFieldsError({
      roleGroupsError: "",
      descriptionError: "",
    });
    RoleDatas();
    localStorage.setItem("screenMode", "");
    setIsLoading(false);
  };

  //This is Role Master grid data bind functionality.
  const RoleDatas = async () => {
  try {
    setIsLoading(true);
    const { data } = await BindAPI("RoleAPI/BindRole");
    setbindRoleMasterDatas(data?.Table ?? []);
        if (data?.Table.length > 0) {
      setVisibleTable(true);
      setVisibleAdd(false);
    } else {
      showAdd();
    }
  } catch (error) {
    console.error("Error fetching role data:", error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  RoleDatas();
}, []);


  // this function is helped to the viwe, delete, block and unblock input value via rowindex passing.
  const handleRole = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setRoleData(bindRoleMasterDatas[rowIndex]);
  };

  // this function is helped to edit the input value via rowindex passing and helping to visible handling.
  const handleEdit = (rowIndex) => {
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex); // store index

    const data = bindRoleMasterDatas[rowIndex]; // safety
    if (!data) return;
    setVisibleUpdate(true);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setRoleFields({
      roleGroups: bindRoleMasterDatas[rowIndex].RoleName,
      description: bindRoleMasterDatas[rowIndex].RoleDiscription,
    });
    setMstRoleId(bindRoleMasterDatas[rowIndex].MstRoleId);
  };

  const validate = () => {
    const errors = {};
    if (!roleFields.roleGroups || roleFields.roleGroups.trim() === "") {
      errors.roleGroups = "Enter Role";
    } 
    // else if (!/^[A-Za-z ]+$/.test(roleFields.roleGroups)) {
    //   errors.roleGroups = "Only alphabets and spaces allowed";
    // } 
    else {
      const trimmedInput = roleFields.roleGroups.trim().toLowerCase();
      const existingRole = bindRoleMasterDatas.find(
        (x) => x.RoleName.trim().toLowerCase() === trimmedInput
      );

      if (!visibleUpdate && existingRole) {
        // Adding, and role already exists
        errors.roleGroups = "Role already available";
      } else if (
        visibleUpdate &&
        existingRole &&
        existingRole.MstRoleId !== mstRoleId
      ) {
        // Updating, and role name exists under a different ID
        errors.roleGroups = "Role already available";
      }
    }
    // if (!roleFields.roleGroups || roleFields.roleGroups.trim() === "") {
    //   errors.roleGroups = "Enter Role";
    // } else if (!/^[A-Za-z ]+$/.test(roleFields.roleGroups)) {
    //   errors.roleGroups = "Only alphabets and spaces allowed";
    // } else if (
    //   !visibleUpdate &&
    //   bindRoleMasterDatas.find(
    //     (x) => x.RoleName.toLowerCase() === roleFields.roleGroups.toLowerCase()
    //   )
    // ) {
    //   errors.roleGroups = "Role already available";
    // }
    setRoleFieldsError({
      ...roleFieldsError,
      roleGroupsError: errors.roleGroups || "",
    });
    return errors;
  };
  // this function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API response for those all and passing the rowindex.
  // const handleSubmit = async (items, flag) => {
  //   setSubmitBtnDisabled(true);
  //   const validation = validate(flag);
  //   if (Object.keys(validation).length !== 0) {
  //     setIsOpen(true);
  //   }
  //   if (Object.keys(validation).length === 0) {
  //     setIsOpen(false);
  //     setIsLoading(true);
  //     var createdBy = sessionStorage.getItem("createdBy");
  //     if (flag == 1 || flag == 2) {
  //       const data = {
  //         mstRoleId: mstRoleId ? mstRoleId : 0,
  //         roleName: roleFields.roleGroups,
  //         roleDiscription: roleFields.description,
  //         createdBy: createdBy,
  //         flag: flag,
  //       };
  //       const response = await IUDAPI([data], "RoleAPI/IUDRole");
  //       if (flag == 1) {
  //         if (response.data.Table[0].Result === "S") {
  //           toast.success("New role added successfully! 👍", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //           RoleDatas();
  //         } else {
  //           toast.error("Role creation failed 👎", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //         }
  //       } else if (flag == 2) {
  //         if (response.data.Table[0].Result === "M") {
  //           toast.success("Role modified successfully! 👍", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //           RoleDatas();
  //         } else {
  //           toast.error("Role modification failed 👎", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //         }
  //       }
  //     } else {
  //       const data = {
  //         mstRoleId: bindRoleMasterDatas[items].MstRoleId,
  //         createdBy: createdBy,
  //         flag: flag,
  //       };
  //       const response = await IUDAPI([data], "RoleAPI/IUDRole");
  //       if (flag == 3) {
  //         if (response.data.Table[0].Result === "D") {
  //           toast.success("Role deleted successfully! 👍", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //           RoleDatas();
  //         } else {
  //           toast.error("Role deletion failed 👎", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //         }
  //       } else if (flag == 4) {
  //         if (response.data.Table[0].Result === "B") {
  //           toast.success("Role Inactivated successfully! 👍", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //           RoleDatas();
  //         } else {
  //           toast.error("Role Inactivated failed 👎", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //         }
  //       } else if (flag == 5) {
  //         if (response.data.Table[0].Result === "UB") {
  //           toast.success("Role activated successfully! 👍", {
  //             duration: 5000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //           RoleDatas();
  //         } else {
  //           toast.error("Role activated failed! 👎", {
  //             duration: 3000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 3000);
  //         }
  //       }
  //     }
  //   } else {
  //     setSubmitBtnDisabled(false);
  //   }
  // };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    const validation = validate(flag);

    var createdBy = sessionStorage.getItem("createdBy");
    if (flag == 1 || flag == 2) {
      if (Object.keys(validation).length !== 0) {
        setIsOpen(true);
      }
      if (Object.keys(validation).length === 0) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          mstRoleId: mstRoleId ? mstRoleId : 0,
          roleName: roleFields.roleGroups,
          roleDiscription: roleFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "RoleAPI/IUDRole");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("New role added successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
            RoleDatas();
          } else {
            toast.error("Role creation failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Role modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
            RoleDatas();
          } else {
            toast.error("Role modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstRoleId: bindRoleMasterDatas[items].MstRoleId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "RoleAPI/IUDRole");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Role deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
          RoleDatas();
        } else {
          toast.error("Role deletion failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Role Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
          RoleDatas();
        } else {
          toast.error("Role Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Role activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
          RoleDatas();
        } else {
          toast.error("Role activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/rolemaster") {
      const screenMode = localStorage.getItem("screenMode");

      if (screenMode === "add") {
        showAdd();
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindRoleMasterDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindRoleMasterDatas]);
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading &&(
        <GridPage
          title="Role Master"
          header={roleMasterHeader}
          records={bindRoleMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleRole}
          showAdd={showAdd}
          blockView={false}
        />
      )}
      {visibleAdd && (
        <div class="flex flex-col w-full">
          <div class={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Role Master"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Role"}
                      name={"rolegroups"}
                      content={roleFields.roleGroups}
                      controlFunc={(e) =>
                        setRoleFields({
                          ...roleFields,
                          roleGroups: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setRoleFieldsError((roleFieldsError) => {
                          const input = roleFields.roleGroups;
                          let error = "";

                          if (!input || input.trim() === "") {
                            error = "Enter Role";
                          } 
                          // else if (!/^[A-Za-z ]+$/.test(input)) {
                          //   error = "Only alphabets and spaces allowed";
                          // } 
                          else {
                            const trimmedInput = input.trim().toLowerCase();
                            const existingRole = bindRoleMasterDatas.find(
                              (x) =>
                                x.RoleName.trim().toLowerCase() === trimmedInput
                            );

                            if (!visibleUpdate && existingRole) {
                              // Adding, and role already exists
                              error = "Role already available";
                            } else if (
                              visibleUpdate &&
                              existingRole &&
                              existingRole.MstRoleId !== mstRoleId
                            ) {
                              // Updating, and role name exists under a different ID
                              error = "Role already available";
                            }
                          }

                          return {
                            ...roleFieldsError,
                            roleGroupsError: error,
                          };
                        });
                      }}
                      //                       controlFuncBlur={(e) => {
                      //                         setRoleFieldsError((roleFieldsError) => {
                      //                           const input = roleFields.roleGroups;
                      //                           let error = "";
                      //
                      //                           if (!input || input.trim() === "") {
                      //                             error = "Enter Role";
                      //                           } else if (!/^[A-Za-z ]+$/.test(input)) {
                      //                             error = "Only alphabets and spaces allowed";
                      //                           } else if (
                      //                             !visibleUpdate &&
                      //                             bindRoleMasterDatas.find(
                      //                               (x) =>
                      //                                 x.RoleName.toLowerCase() === input.toLowerCase()
                      //                             )
                      //                           ) {
                      //                             error = "Role already available";
                      //                           }

                      //                           return {
                      //                             ...roleFieldsError,
                      //                             roleGroupsError: error,
                      //                           };
                      //                         });
                      //                       }}
                      errorMessage={roleFieldsError.roleGroupsError}
                    />

                    <TextArea
                      inputType="text"
                      title="Description"
                      name="description"
                      rows="4"
                      content={roleFields.description}
                      controlFunc={(e) =>
                        setRoleFields({
                          ...roleFields,
                          description: e.target.value,
                        })
                      }
                    />

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleRole}
      >
        <div>
          <PopUpScreenTitle
            title="Role Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <Role data={roleData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default RoleMaster;
